






















































import Vue from 'vue'
const vueJsonEditor = require('vue-json-editor').default

import { AlarmSetting } from '@/api/alarm'

export default Vue.extend({
  props: {
    value: Object,
    devices: Array,
  },
  components: {
    vueJsonEditor,
  },
  data() {
    return {
      optsClass: [
        { text: 'Error', value: 'error' },
        { text: 'Warning', value: 'warning' },
      ],
      model: {} as AlarmSetting,
    }
  },

  methods: {
    onJsonChange() {
      //
    },
  },

  watch: {
    value: function(val: AlarmSetting) {
      this.model = val
    },
  },
})
